import React from "react";
import { Check, CheckCheck } from "lucide-react";

function MessageStatus({ message }) {
  if (message?.direction !== "Outgoing") {
    return null;
  }

  if (message?.status === "Read") {
    return (
      <CheckCheck size={13} strokeWidth={2.2} className="text-[#53bdeb]"/>
    );
  }

  if (message?.status === "Delivered") {
    return (
      <CheckCheck size={13} strokeWidth={2.2} className="text-[#667781]"/>
    );
  }

  return (
    <Check size={13} strokeWidth={2.2} className="text-[#667781]"/>
  );
}

export default MessageStatus;